import { FooterStyles } from "../styles";
import { Link } from "react-router-dom";

function FooterComponent() {
  return (
    <FooterStyles>
      <div className="top-bar">
        <div>
          <Link to="/designs">Designs</Link>
          <Link to="/size-guide">Size Guide</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/order-lookup">Order Lookup</Link>
        </div>

        <div className="questions">
          <span>Have a Question?</span>
          <a
            href="mailto:support@greygullapparel.com?subject=Grey Gull Apparel Question"
            aria-label="Have a question? Email us at support@greygullapparel.com"
          >
            support@greygullapparel.com
          </a>
        </div>

        <div className="policies">
          <Link to="/return-policy">Returns</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-use">Terms of Use</Link>
        </div>
      </div>
      <div className="bottom-bar">
        <div className="copyright">
          <div>© 2025 Grey Gull Apparel</div>
          <div>All Rights Reserved.</div>
        </div>

        {/* <div className="social">
          <span>Follow Us:</span>
          <div>
            <a href="#" target="_blank">
              <i className="fa-brands fa-facebook"></i>
            </a>
            <a href="#" target="_blank">
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="#" target="_blank">
              <i className="fa-brands fa-tiktok"></i>
            </a>
          </div>
        </div> */}
      </div>
    </FooterStyles>
  );
}

export default FooterComponent;
